export default {
  total_saving: {
    co2: 'Total kgCO\u2082e ahorrado',
    points: 'Total de puntos ganados',
  },
  total_participants: 'Total de participantes',
  total_activities: 'Actividades registradas',
  all: 'Todos los %{term}',
  series_terms: {
    series: 'series',
    company_size: 'tamaños de empresa',
    cities: 'ciudades',
    counties: 'provincias',
    industries: 'industrias',
  },
  campaign_terms: {
    campaigns: 'campañas',
    schools: 'escuelas',
    companies: 'empresas',
  },
  days_until_start:
    '%{smart_count} día hasta que comience el campeonato |||| %{smart_count} días hasta que comience el campeonato',
  now_over: 'Este campeonato ha terminado',
  average: {
    co2: 'kgCO\u2082e ahorrado de media por participante',
    co2_and_participation:
      'kgCO\u2082e ahorrado de media por participante Y al menos %{requiredParticipation}% de participación alcanzada',
    points: 'puntos de media por participante',
  },
  not_reached_participation:
    'aún no se ha alcanzado el %{requiredParticipation}% de participación, que es necesario para ganar.',
};
